import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { User, LogOut, Settings, ChevronDown, Shield, Mail } from 'lucide-react';

export const UserMenu: React.FC = () => {
  const { user, profile, isAdmin, signOut } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Errore durante il logout:', error);
    }
  };

  if (!user || !profile) return null;

  const displayName = profile.first_name && profile.last_name 
    ? `${profile.first_name} ${profile.last_name}`
    : user.email?.split('@')[0] || 'Utente';

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-3 px-4 py-2 bg-gray-800/50 hover:bg-gray-800/70 border border-gray-700 rounded-lg transition-all duration-200"
      >
        <div className="flex items-center space-x-2">
          <div className="p-1.5 bg-blue-400/10 rounded-lg">
            <User className="h-4 w-4 text-blue-400" />
          </div>
          <div className="text-left">
            <p className="text-sm font-medium text-white">{displayName}</p>
            <div className="flex items-center space-x-2">
              {isAdmin && (
                <div className="flex items-center space-x-1">
                  <Shield className="h-3 w-3 text-yellow-400" />
                  <span className="text-xs text-yellow-400">Admin</span>
                </div>
              )}
              <span className="text-xs text-gray-400">{profile.role}</span>
            </div>
          </div>
        </div>
        <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          {/* Overlay per chiudere il menu */}
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Menu dropdown */}
          <div className="absolute right-0 mt-2 w-64 bg-gray-800 border border-gray-700 rounded-lg shadow-xl z-20">
            {/* Header del menu */}
            <div className="px-4 py-3 border-b border-gray-700">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-blue-400/10 rounded-lg">
                  <User className="h-5 w-5 text-blue-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-white">{displayName}</p>
                  <div className="flex items-center space-x-2 mt-1">
                    <Mail className="h-3 w-3 text-gray-400" />
                    <p className="text-xs text-gray-400">{user.email}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Informazioni profilo */}
            <div className="px-4 py-3 border-b border-gray-700">
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-400">Ruolo:</span>
                  <div className="flex items-center space-x-1">
                    {isAdmin && <Shield className="h-3 w-3 text-yellow-400" />}
                    <span className={`text-xs font-medium ${isAdmin ? 'text-yellow-400' : 'text-gray-300'}`}>
                      {profile.role}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-400">Profilo:</span>
                  <span className={`text-xs ${profile.profile_completed ? 'text-green-400' : 'text-yellow-400'}`}>
                    {profile.profile_completed ? 'Completato' : 'Incompleto'}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-400">Membro dal:</span>
                  <span className="text-xs text-gray-300">
                    {new Date(profile.created_at).toLocaleDateString('it-IT')}
                  </span>
                </div>
              </div>
            </div>

            {/* Azioni del menu */}
            <div className="py-2">
              <button
                onClick={() => {
                  setIsOpen(false);
                  // TODO: Implementare la pagina delle impostazioni
                }}
                className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-gray-300 hover:bg-gray-700/50 transition-colors"
              >
                <Settings className="h-4 w-4" />
                <span>Impostazioni Profilo</span>
              </button>
              
              <button
                onClick={() => {
                  setIsOpen(false);
                  handleSignOut();
                }}
                className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-red-400 hover:bg-red-900/20 transition-colors"
              >
                <LogOut className="h-4 w-4" />
                <span>Disconnetti</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};